// import moment from 'moment';
import * as actionTypes from "../action-types";
import * as api from "../../api";
// import { v4 as uuidv4 } from "uuid";
import { has } from 'lodash'
// import { toBoolean } from '../StoreHelpers';

export const portalFlow =
    ({ dispatch, getState }) =>
    (next) =>
    (action) => {
        next(action);
        switch (action.type) {

            case actionTypes.ON_CANCEL_PAYWAY:
                dispatch({ type: actionTypes.ON_PROCEED_RESET });
            break;

            case actionTypes.ON_CONTINUE_THANK_YOU:

                dispatch({ type: actionTypes.API_PAYWAY_REFERENCE_START });

                api.put(`/web-convincely/v1.0/api/payment-plan/payway-reference-number`, {
                    paywayReferenceNumber: `PP${getState().authReducer.accountNumber}`,
                    requestNumber: getState().appReducer.payment.data.requestNumber
                })
                .then((response) => {
                    console.log('SUCCESS', 'response.data', response.data);
                    dispatch({ type: actionTypes.ON_PROCEED_RESET });
                })
                .catch((error) => {
                    dispatch({ type: actionTypes.API_PAYWAY_REFERENCE_FAIL, payload: error });
                });

            break;

            case actionTypes.ON_CONFIRM_PAYMENT:

                dispatch({ type: actionTypes.API_PAYMENT_PLAN_START });
                api.post(`/web-convincely/v1.0/api/payment-plan`, {
                    accountNumber: getState().authReducer.accountNumber,
                    channel: 'Website',
                    agreePPTerms: true,
                    noOfInstallments: 0,
                    paywayReferenceNumber: `PP${getState().authReducer.accountNumber}`,
                    ...getState().appReducer.repaymentOption.input
                })
                .then((response) => {
                    console.log('SUCCESS', 'response.data', response.data);
                    dispatch({
                        type: actionTypes.API_PAYMENT_PLAN_SUCCESS,
                        payload: response.data
                    });
                })
                .catch((error) => {
                    dispatch({ type: actionTypes.API_PAYMENT_PLAN_FAIL, payload: error });
                });

            break;

        case actionTypes.SET_PAYMENT_METHOD:
            // clear/reset previous frames
            // eslint-disable-next-line
            $("#payway-bank-account").empty();
            // eslint-disable-next-line
            $("#payway-credit-card").empty();

            let options = {
                publishableApiKey: api.PAYWAY_API_KEY,
                tokenMode: 'callback',
                layout: 'wide',
                onValid: () => {
                  // Remove handling if not needed
                  console.log('account valid')
                },
                onInvalid: () => {
                    console.log('account valid')
                }
            }

            // Store frame to fetch token later on
            let createdCallback = function (err, frame) {
                if (err) {
                  console.error('Error creating payway frame: ' + err.message)
                } else {
                    dispatch({
                        type: actionTypes.SET_PAYMENT_FRAME,
                        payload: frame,
                    });
                }
            }

            // Generate PayWay Form
            try {
                if (getState().appReducer.payment.input.paymentMethod==='CREDIT_CARD') {
                    // eslint-disable-next-line
                    payway.createCreditCardFrame(options, createdCallback);
                } else if (getState().appReducer.payment.input.paymentMethod==='BANK_ACCOUNT') {
                    // eslint-disable-next-line
                    payway.createBankAccountFrame(options, createdCallback);
                }
            } catch (err) {
                console.log(err)
            }
            break;

        case actionTypes.ON_SUBMIT_PAYMENT:

                dispatch({
                    type: actionTypes.SET_SPLASH_WAIT,
                    payload: {
                        show: true
                    },
                });

                const tokenCallback = (err, data) => {
                    if (err) {
                      console.error('Error getting token: ' + err.message)
                        dispatch({
                            type: actionTypes.SET_SPLASH_WAIT,
                            payload: {
                                show: false
                            },
                        });

                        dispatch({ type: actionTypes.PAYWAY_TRANSACT_ERROR });
                    } else {
                      // console.log('Token Data: ', data)
                      // console.log('singleUseTokenId: ' + data.singleUseTokenId)
                      dispatch({
                        type: actionTypes.SET_PAYMENT_TOKEN,
                        payload: data.singleUseTokenId,
                      });
                      processPayment();
                    }
                }

                const processPayment = () => {
                    dispatch({ type: actionTypes.API_PAYMENT_START });

                    let alreadyDd = getState().authReducer.alreadyDd

                    let account = ''
                    if(alreadyDd) {
                        account = getState().authReducer.customerReference
                    } else {
                        account = getState().authReducer.accountNumber
                    }
                    let token = getState().appReducer.payment.input.singleUseToken;
                    api.post(`/web-convincely/v1.0/api/payment-plan/account/PP${account}/payment-details/save?token=${token}`)
                    .then((response) => {
                        if(response.data.success === true){
                            console.log(response)
                            dispatch({
                                type: actionTypes.API_PAYMENT_SUCCESS,
                                payload: response.data,
                            });
                        } else {
                            dispatch({
                                type: actionTypes.API_PAYMENT_FAIL,
                                payload: {
                                    message: response.data?.message ? response.data?.message : 'Payment failed. please check your details and try again'
                                }
                            });
                        }
                    })
                    .catch((error) => {
                        dispatch({ type: actionTypes.API_PAYMENT_FAIL,
                            payload: {
                                message: error.data?.message ? error.data?.message : 'Payment failed. please check your details and try again'
                            }
                         });
                    })
                    .finally(() => {
                        dispatch({
                            type: actionTypes.SET_SPLASH_WAIT,
                            payload: {
                                show: false
                            },
                        });
                    });
                }

                // get token from frame
                let frame = getState().appReducer.payment.input.paymentFrame;
                frame.getToken(tokenCallback)

                break;

            default:
                break;
        }
    };

export const loyaltyMDL = [portalFlow];
